export function getThemeId(type) {
    return type === 'checkbox' ? type : 'radiobutton';
}
